<div *ngIf="!verified" class="d-flex justify-content-center align-items-center w-100 h-100">
    <div>
        <div class="card border-0 box-shadow rounded-0 width-size">
            <div class="card-header d-flex justify-content-center align-items-center border border-white bg-white mt-1">
                <img src="/assets/img/FMS.png" class="img-fluid rounded mx-auto d-block" width="60%">
            </div>

            <h3 class="card-title head1 d-flex justify-content-center align-items-center border border-white bg-white">
                Hello! Please Signup</h3>
            <div class="card-body text-center" style="margin-top: -5.5%;">

                <form [formGroup]="LoginForm" class="text-left mt-4">
                    <div class="form-group" style="margin-bottom: 4px">
                        <label>Email <sup style="color:red; font-size: 1.35em;
                        top: 0em;">&nbsp;*</sup></label>
                        <input class="form-control login-input" type="text" autocomplete="off" formControlName="Email"
                            name="Email" [(ngModel)]="Create.email">
                    </div>
                    <div *ngIf="LoginForm.controls.Email.errors ">
                        <div style="color:red;text-align: left;" *ngIf="LoginForm.controls.Email.errors.required">
                            Required</div>
                    </div>

                    <div class="form-group" style="margin-bottom: 4px">
                        <label>Password<sup style="color:red; font-size: 1.35em;
                            top: 0em;">&nbsp;*</sup></label>
                        <input class="form-control login-input" style="border-color:#ced4da;" type="password"
                            autocomplete="off" formControlName="password" [(ngModel)]="Create.password"
                            name="agencycode">
                    </div>
                    <span class="help-block text-danger text-center"
                        *ngIf="!LoginForm.get('password').valid && LoginForm.get('password').touched">
                        Required
                    </span>
                    <div class="form-group" style="margin-bottom: 4px">
                        <label>Confirm Password<sup style="color:red; font-size: 1.35em;
                                top: 0em;">&nbsp;*</sup></label>
                        <input class="form-control login-input" style="border-color:#ced4da;" type="password"
                            autocomplete="off" formControlName="Confirm_password" name="Confirm_password">
                    </div>
                    <span class="text-danger" *ngIf="LoginForm.get('Confirm_password').touched">
                        <span *ngIf="LoginForm.get('Confirm_password').hasError('required')"> Required</span>
                        <span *ngIf="LoginForm.get('Confirm_password').hasError('mismatchedPasswords')">Passwords do not
                            match</span>
                    </span>

                    <button type="submit" class="btn"
                        style="color: black;height: 26px;width:100%;background-color: #f4cf12;padding: 0 !important"
                        [disabled]="!LoginForm.valid" (click)="RegisterDetails()">Proceed</button>
                </form>

                <div class="mt-4">
                    <button type="submit" class="btn"
                        style="color: black;height: 26px;width:100%;background-color: #f4cf12;padding: 0 !important"
                        (click)="cancel()">Cancel</button>

                </div>

                <div class="text-center border border-white bg-transparent">
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="verified" class="d-flex justify-content-center align-items-center w-100 h-100">
    <div>
        <div class="card border-0 box-shadow rounded-0 width-size">
            <div class="card-header d-flex justify-content-center align-items-center border border-white bg-white mt-1">
                <img src="/assets/img/cover.png" style="height: 100px;width: 250px;">
            </div>
            <div class="card-body text-center" style="margin-top: -5.5%;">

                <form [formGroup]="LoginForm">
                    <div class="form-group" style="margin-bottom: 4px">
                        <label>User Name <sup style="color:red; font-size: 1.35em;
                        top: 0em;">&nbsp;*</sup></label>
                        <input class="form-control login-input" placeholder="User Name/Email/Phone" type="text"
                            autocomplete="off" formControlName="Email" name="Email">
                    </div>
                    <div *ngIf="LoginForm.controls.Email.errors ">
                        <div style="color:red;text-align: left;" *ngIf="LoginForm.controls.Email.errors.required">User
                            Email is
                            required</div>
                    </div>
                    <div class="form-group" style="margin-bottom: 4px">
                        <label>New Password <sup style="color:red; font-size: 1.35em;
                        top: 0em;">&nbsp;*</sup></label>
                        <input class="form-control login-input" placeholder="User Name/Email/Phone" type="text"
                            autocomplete="off" formControlName="Email" name="Email">
                    </div>
                    <div *ngIf="LoginForm.controls.Email.errors ">
                        <div style="color:red;text-align: left;" *ngIf="LoginForm.controls.Email.errors.required">User
                            Email is
                            required</div>
                    </div>
                    <div class="form-group" style="margin-bottom: 4px">
                        <label>Confirm Password <sup style="color:red; font-size: 1.35em;
                        top: 0em;">&nbsp;*</sup></label>
                        <input class="form-control login-input" placeholder="User Name/Email/Phone" type="text"
                            autocomplete="off" formControlName="Email" name="Email">
                    </div>
                    <div *ngIf="LoginForm.controls.Email.errors ">
                        <div style="color:red;text-align: left;" *ngIf="LoginForm.controls.Email.errors.required">User
                            Email is
                            required</div>
                    </div>
                    <br>

                    <br>
                    <div class="row">

                    </div>

                    <button type="button" class="btn"
                        style="color: black;height: 26px;width:100%;background-color: #f4cf12;padding: 0 !important"
                        (click)="register()">Register</button>
                </form>


                <div class="text-center border border-white bg-transparent">

                </div>
            </div>
        </div>
    </div>
</div>
<span id="openModal1" data-target="#myModal" data-toggle="modal"></span>
<div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Verify OTP</h5>

            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col">
                        <label style=" 
                font-size: 16px;
                font-weight: 600;
                margin-top: 4px;">
                            Enter OTP</label>

                        <input class="form-control login-input" type="text" autocomplete="off">
                    </div>

                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-sm" style="background-color: #f4cf12;" (click)="verified=true;"
                    data-dismiss="modal">Verify</button>

                <button class="btn  btn-sm" data-dismiss="modal">Close</button>


            </div>
        </div>
    </div>

</div>